import React from 'react';
import PropTypes from 'prop-types';
import trendingMock from './trending-mock.json';
import { Analytics } from 'packages';
import { hot } from 'react-hot-loader';
import { useTranslator, useUrlLocalizer } from 'tradera-lang';

import './trending-tags.scss';

const TrendingTags = ({ initData }) => {
    const { t } = useTranslator();
    const { toLocalizedUrl } = useUrlLocalizer();

    const handleTagClick = label => {
        Analytics.trackEvent({
            category: 'Search',
            action: 'Navigation',
            label: label
        });
    };

    const {
        featureSwitches,
        trendingBrands = [],
        trendingSearches = []
    } = initData;

    const {
        searches: trendingSearchesMock,
        brands: trendingBrandsMock
    } = trendingMock;

    const useApi = featureSwitches['start-page-content-integration'];
    const contentFetched =
        trendingBrands.length > 0 && trendingSearches.length > 0;

    if (useApi && !contentFetched) {
        return null;
    }

    const Tag = ({ name, categoryId, url }) => (
        <a
            type="button"
            className="btn btn-md-sm btn-outline-dark btn-tag mr-3 my-2 px-4"
            onClick={() => {
                handleTagClick(name);
            }}
            href={toLocalizedUrl(
                url
                    ? url
                    : `/search?categoryId=${categoryId}&q=${name}&sortBy=MostBids`
            )}>
            {name}
        </a>
    );

    const renderSearches = (trendingSearches, trendingSearchesMock) => {
        const searches = useApi ? trendingSearches : trendingSearchesMock;
        return searches.map((searchTerm, index) => {
            const { query, categoryId } = searchTerm;
            return (
                <Tag
                    name={query}
                    categoryId={categoryId}
                    key={`${query}-${index}`}
                />
            );
        });
    };

    const renderBrands = (trendingBrands, trendingBrandsMock) => {
        const brands = useApi ? trendingBrands : trendingBrandsMock;
        return brands.map((brand, index) => {
            const { name, categoryId, slug } = brand;
            return (
                <Tag
                    name={name}
                    categoryId={categoryId}
                    key={`${name}-${index}`}
                    url={slug ? `/brand/${slug}` : slug}
                />
            );
        });
    };

    return (
        <div className="row">
            <div className="col-md-6 col-12 pb-md-0 pb-3">
                <h5 className="text-center-align text-styled">
                    {t('trendingTags_brands')}
                    <span className="d-inline d-md-none">:</span>
                </h5>
                <div className="tag-wrapper d-flex flex-md-wrap justify-content-md-center justify-content-start py-2">
                    {renderBrands(trendingBrands, trendingBrandsMock)}
                </div>
            </div>
            <div className="col-md-6 col-12">
                <h5 className="text-center-align text-styled">
                    {t('trendingTags_searches')}
                    <span className="d-inline d-md-none">:</span>
                </h5>
                <div className="tag-wrapper d-flex flex-md-wrap justify-content-md-center justify-content-start py-2">
                    {renderSearches(trendingSearches, trendingSearchesMock)}
                </div>
            </div>
        </div>
    );
};

TrendingTags.propTypes = {
    initData: PropTypes.object.isRequired
};

export default hot(module)(TrendingTags);
